import styled from 'styled-components';
import { SubTitle } from '../../atoms/Fonts';

export const ForgotPasswordStepOneContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Subheader = styled(SubTitle)`
  color: ${(props) => props.theme.colors.text.default};
  margin-top: 8px;
`;

export const FormWrapper = styled.div`
  margin-bottom: 24px;
  width: 100%;
`;

export const FieldWrapper = styled.div`
  margin: 24px 0;
`;
